/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import { formatNumberToINRCommaSeparatedString } from '@/root/utils/common/numbers/format-number-to-string'
import useGetINStockLivePriceFromSocket from '../LivePrices/useGetINStockLivePriceFromSocket'
import { useState } from 'react'
import { TLivePrice } from '../Pages/INStockDetailPage/types'
import { getChangeUpOrDownArrow } from './Dashboard/MyHoldings'

export default function HoldingBottomComponent({
  average_price,
  invested_amount,
  current_value,
  overall_pnl,
  day_pnl,
  socket_path,
  quantity,
  prevClose,
  overall_pnl_perc,
  day_pnl_perc,
  mode,
}: {
  average_price?: number
  invested_amount?: number
  current_value?: number
  overall_pnl?: number | null
  socket_path?: string
  day_pnl?: number | null
  quantity?: number
  prevClose?: number
  overall_pnl_perc?: number
  day_pnl_perc?: number
  mode?: 'delivery' | 'holding' | 'intraday'
}) {
  const [livePrice, setLivePrice] = useState<TLivePrice | null>(null)

  useGetINStockLivePriceFromSocket(socket_path, setLivePrice)

  const currValue =
    livePrice?.price && quantity
      ? livePrice.price * quantity
      : current_value ?? 0

  const overall_pnl_live =
    livePrice?.price && overall_pnl
      ? currValue - (invested_amount ?? 0)
      : overall_pnl

  const daypnlLive =
    livePrice?.price && prevClose && quantity
      ? (livePrice.price - prevClose) * quantity
      : day_pnl

  return (
    <section className="mt-1 flex gap-6 overflow-x-auto px-4 pb-4 md:flex md:justify-between">
      {typeof average_price !== 'undefined' && (
        <div className="min-w-[60px] flex-shrink-0">
          <p className="text-brand-grey-base text-sm">Average Price</p>

          <p>{formatNumberToINRCommaSeparatedString(average_price)}</p>
        </div>
      )}
      {typeof invested_amount !== 'undefined' && (
        <div className="min-w-[86px] flex-shrink-0 ">
          <p className="text-brand-grey-base text-sm">Invested value</p>

          <p className="break-all text-left">
            {formatNumberToINRCommaSeparatedString(invested_amount)}
          </p>
        </div>
      )}
      {typeof currValue !== 'undefined' && (
        <div className="min-w-[72px]  flex-shrink-0 ">
          <p className="text-brand-grey-base text-sm">Current value</p>

          {currValue === 0 ? (
            '-'
          ) : (
            <p className="break-all">
              {formatNumberToINRCommaSeparatedString(currValue)}
            </p>
          )}
        </div>
      )}
      {typeof overall_pnl_live === 'number' && (
        <div className="min-w-[69px] flex-shrink-0">
          <p className="text-brand-grey-base text-right text-sm">
            Total Returns
          </p>

          <p className={`break-all`}>
            {formatNumberToINRCommaSeparatedString(overall_pnl_live)}{' '}
            <span
              className={`text-sm  ${
                overall_pnl_live > 0
                  ? 'text-brand-green-dark'
                  : 'text-brand-red-cinnabar'
              }`}
            >
              {overall_pnl_perc && getChangeUpOrDownArrow(overall_pnl_perc)}

              {overall_pnl_perc?.toFixed(2)}
              {overall_pnl_perc && '%'}
            </span>
          </p>
        </div>
      )}
      {typeof daypnlLive === 'number' && (
        <div className="min-w-[69px] flex-shrink-0">
          <p className="text-brand-grey-base text-right text-sm">
            {mode === 'intraday' ? 'Gain/Loss' : '1D gain/loss'}
          </p>

          <p className={`break-all`}>
            {formatNumberToINRCommaSeparatedString(daypnlLive)}{' '}
            <span
              className={`text-sm  ${
                daypnlLive > 0
                  ? 'text-brand-green-dark'
                  : 'text-brand-red-cinnabar'
              }`}
            >
              {day_pnl_perc && getChangeUpOrDownArrow(day_pnl_perc)}
              {day_pnl_perc?.toFixed(2)}
              {day_pnl_perc && '%'}
            </span>
          </p>
        </div>
      )}
    </section>
  )
}
